import { makeObservable, observable } from 'mobx';
import { Subscription } from '../model/subscription';
import { msToTimestamp } from '../utils/date';
import CompanyStore from './CompanyStore';
import { updateCompany, updateReseller, updateResellerCompanySubscription } from '../api/admin';
import { Message, MessageSeverity } from '../model/Message';

class SubscriptionStore {
  companyStore: CompanyStore;

  subscription: Subscription[] = [];

  loading = false;

  message: Message = { text: '', severity: undefined };

  constructor(companyStore: CompanyStore) {
    this.companyStore = companyStore;
    makeObservable(this, {
      loading: observable,
      subscription: observable,
      companyStore: observable,
    });
  }

  setSubscriptionStatus(key: string, subKey: string, ms: number): void {
    if (!this.companyStore.data) {
      return;
    }

    if (this.companyStore.companyKey === key) {
      if (
        this.companyStore.data?.subscriptions.findIndex((a: Subscription) => a.id === subKey) === -1
      ) {
        this.companyStore.data.subscriptions = [
          // eslint-disable-next-line no-unsafe-optional-chaining
          ...this.companyStore.data?.subscriptions,
          {
            id: subKey,
            data: {
              status: new Date(ms) > new Date() ? 'active' : 'inactive',
              endDate: msToTimestamp(ms),
            },
          },
        ];
      } else {
        this.companyStore.data.subscriptions = this.companyStore.data.subscriptions.map(
          (sub: Subscription) => {
            if (sub.id === subKey) {
              if (new Date(ms) > new Date()) {
                return {
                  ...sub,
                  data: {
                    status: 'active',
                    endDate: msToTimestamp(ms),
                  },
                };
              }
              return {
                ...sub,
                data: {
                  status: 'inactive',
                  endDate: msToTimestamp(ms),
                },
              };
            }
            return sub;
          },
        );
      }
    }
  }

  async saveSubscription(companyKey: string): Promise<void> {
    if (!this.companyStore.data) {
      return;
    }
    await updateCompany(
      companyKey,
      this.companyStore.data.subscriptions,
      this.companyStore.data.subscriptionExpires,
      this.companyStore.data.controlUnitMode,
    );
  }

  async saveResellerSubscription(companyKey: string, resellerId: string): Promise<void> {
    if (!this.companyStore.data) {
      return;
    }
    await updateResellerCompanySubscription(
      companyKey,
      resellerId,
      this.companyStore.data.subscriptions,
    );
  }

  updateReseller = async (companyId: string, resellerId: string) => {
    updateReseller(companyId, resellerId);
  };

  setMessage = (text: string, severity: MessageSeverity) => {
    this.message = { text, severity };
  };

  resetMessage = () => {
    this.message = { text: '', severity: undefined };
  };
}

export default SubscriptionStore;
